// CSS Modules - component class name prefix: ProductSlider__

<template>
  <div :class="$style.container">
    <hr :class="$style.line" />
    <h2 :class="$style.title" v-if="config.title">{{ config.title }}</h2>
    <div :class="$style.slider">
      <agile
        :options="sliderOptions"
        :key="`agileSlider_${config.products.length}`"
      >
        <figure
          v-for="(product, index) in config.products"
          :key="index"
          :class="[!isMobile && $style.notMobile, $style.slideFigure]"
        >
          <a
            :class="$style.mediaLink"
            :href="product.primaryLink"
			:navigationID="product.navigationID"
			:navigationType="product.navigationType"
            target="_self"
          >
            <img :src="product.image" :alt="product.title" />
          </a>
          <figcaption>
            <a
              :class="$style.primaryLink"
              :href="product.primaryLink"
			  :navigationID="product.navigationID"
			  :navigationType="product.navigationType"
              target="_self"
            >
              <div v-if="!config.isShop">{{ product.type }}</div>
              <p
                v-if="!config.isShop"
                :class="$style.productTitle"
                v-html="product.title"
              ></p>
              <p
                v-if="config.isShop"
                :class="$style.productTitle"
                v-html="product.title"
              ></p>
              <div v-if="config.isShop">{{ product.type }}</div>
              <div v-if="product.text">{{ product.text }}</div>
              <div v-if="config.isShop" :class="$style.priceTag">
                <strong>{{ product.price }}</strong>
                <span>
                  {{ product.tax }} &amp;
                  <a :href="product.shippingUrl" target="_blank">
                    {{ product.shippingText }}
                  </a>
                </span>
              </div>
            </a>
          </figcaption>
        </figure>
      </agile>
    </div>
  </div>
</template>

<script>
import { VueAgile } from "../vue-agile";

export default {
  name: "ProductSlider",
  components: {
    agile: VueAgile
  },
  props: {
    config: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    const productsLength = this.config.products.length;
    return {
      isMobile: false,
      sliderOptions: {
        navButtons: productsLength > 1,
        speed: 500,
        dots: false,
        infinite: false,
        slidesToShow: 1,
        slidesToMove: productsLength > 1 ? 1 : 0,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              navButtons: productsLength > 2,
              slidesToShow: 2,
              slidesToMove: productsLength > 2 ? 2 : 0
            }
          }
        ]
      }
    };
  },
  methods: {
    checkIsMobile() {
      this.isMobile = window.innerWidth < 780;
    }
  },
  created() {
    this.checkIsMobile();
    window.addEventListener("resize", this.checkIsMobile);
  },
  destroyed() {
    window.removeEventListener("resize", this.checkIsMobile);
  }
};
</script>

<style module lang="scss">
@import "./ProductSlider.scss";
</style>
